const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const formatLocalIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const isValidIsoDateString = (value: string): boolean => {
  if (!ISO_DATE_PATTERN.test(value)) {
    return false;
  }

  const parsed = parseIsoDateToLocal(value);
  return parsed !== undefined && formatLocalIsoDate(parsed) === value;
};

export const parseIsoDateToLocal = (iso: string): Date | undefined => {
  if (!ISO_DATE_PATTERN.test(iso)) {
    return undefined;
  }

  const [year, month, day] = iso.split('-').map(Number);
  const parsed = new Date(year, month - 1, day);

  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return undefined;
  }

  return parsed;
};

export const normalizeFormDates = (dates: string[]): string[] =>
  dates.map((value) => value.trim()).filter((value) => value.length > 0);

export const isoDatesToLocalDates = (dates: string[]): Date[] =>
  normalizeFormDates(dates)
    .map(parseIsoDateToLocal)
    .filter((date): date is Date => date !== undefined);

export const localDatesToIsoDates = (dates: Date[] | undefined): string[] =>
  [...(dates ?? [])]
    .map(formatLocalIsoDate)
    .sort((a, b) => a.localeCompare(b));

export const removeIsoDate = (dates: string[], iso: string): string[] =>
  dates.filter((value) => value !== iso);

export const formDatesFromSelection = (dates: Date[] | undefined): string[] => {
  const isoDates = localDatesToIsoDates(dates);
  return isoDates.length > 0 ? isoDates : [''];
};
